import { useState, useEffect } from "react";
import { getUserId } from "services/auth";
import { useFetchStoriesByIds, useFetchPublicStories } from "services/stories";

const useLibraryManager = (storyIds = []) => {
  const [library, setLibrary] = useState([]);
  const [others, setOthers] = useState([]);

  const personalLibrary = useFetchStoriesByIds(storyIds);
  const publicLibrary = useFetchPublicStories();
  const userId = getUserId();

  useEffect(() => {
    const { stories, loading } = personalLibrary;
    if (stories?.length > 0 && !loading) {
      setLibrary(
        stories.map((story) => ({
          ...story,
          isOwner: story.userId === userId,
        }))
      );
    }
  }, [personalLibrary.stories.length, personalLibrary.loading, userId]);

  useEffect(() => {
    const { stories, loading } = publicLibrary;
    if (stories?.length > 0 && !loading) {
      setOthers(stories);
    }
  }, [publicLibrary.stories.length, publicLibrary.loading]);

  const updateStory = (storyId, updatedData) => {
    if (!storyId || !updatedData) return;

    const isPersonalStory = library.some((story) => story._id === storyId);
    const setData = isPersonalStory ? setLibrary : setOthers;

    setData((prevStories) =>
      prevStories.map((story) =>
        story._id === storyId ? { ...story, ...updatedData } : story
      )
    );
  };

  return {
    all: [...library, ...others],
    library,
    loadingLibrary: personalLibrary.loading,
    loadingPublic: publicLibrary.loading,
    public: others.filter((story) => story.isPublic),
    updateStory,
  };
};

export default useLibraryManager;
